<div>
  <h2><ng-content></ng-content></h2>
  <div class="line" *ngIf="!hideUnderline"></div>
</div>
<app-cross-close
  *ngIf="!hideCross"
  (click)="iconClicked.emit()"
  dataCy="remove-from-invoice-close-button"
></app-cross-close>
